import store from '@/state/store'

const fields = [
  {
    key: 'vehicle',
    label: 'global.object.licensePlate',
    header: 'licensePlate',
    filter: false,
    width: 20,
  },
  {
    key: 'driver',
    label: 'global.object.driver',
    header: 'driver',
    filter: false,
    width: 20,
  },
  {
    key: 'imei',
    label: 'report.fields.imei',
    header: 'imei',
    filter: false,
    width: 20,
  },
  {
    key: 'deviceType',
    label: 'report.fields.deviceType',
    header: 'deviceType',
    filter: false,
    width: 20,
  },
  {
    key: 'vgroups',
    label: 'report.fields.vehicleGroup',
    header: 'vehicleGroup',
    filter: false,
    width: 20,
  },
  {
    key: 'offlineDate',
    label: 'report.fields.offlineDate',
    header: 'offlineDate',
    filter: false,
    width: 20,
  },
  {
    key: 'totalOfflineTimeSeconds',
    label: 'report.fields.offlineTimeTotal',
    header: 'offlineTimeTotal',
    filter: false,
    width: 10,
  },
  {
    key: 'lastLocation',
    label: 'report.fields.offlineLastPlace',
    header: 'offlineLastPlace',
    filter: false,
    width: 20,
  },
  {
    key: 'lastAlert',
    label: 'report.fields.historyAlertOffline',
    header: 'historyAlertOffline',
    filter: false,
    width: 30,
  },
]

if (store.getters['identity/hasAccess'](['offline_vehicle_geofence_column:read'])) {
  fields.splice(8, 0, {
    key: 'geofence',
    label: 'report.fields.geolocation',
    header: 'geofence',
    filter: false,
    width: 30,
  })
}

export default fields
